import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const patients = [{
  emoji: '🐕',
  name: 'Toby',
  breed: 'Golden Retriever',
  quote: 'Siempre se roba los premios.',
  color: 'bg-primary',
  rotate: '-rotate-2'
}, {
  emoji: '🐈',
  name: 'Luna',
  breed: 'Mestiza',
  quote: 'Reina absoluta de la clínica.',
  color: 'bg-secondary',
  rotate: 'rotate-3'
}, {
  emoji: '🐰',
  name: 'Copito',
  breed: 'Conejo Enano',
  quote: 'Le encantan los mimos en las orejas.',
  color: 'bg-accent',
  rotate: '-rotate-1'
}, {
  emoji: '🐹',
  name: 'Pipo',
  breed: 'Hámster',
  quote: 'Pequeño pero con mucha actitud.',
  color: 'bg-white',
  rotate: 'rotate-2'
}, {
  emoji: '🦜',
  name: 'Paco',
  breed: 'Loro',
  quote: 'Saluda a todos los que entran.',
  color: 'bg-primary',
  rotate: '-rotate-3'
}, {
  emoji: '🐢',
  name: 'Manuelita',
  breed: 'Tortuga',
  quote: 'Viene a su ritmo, pero llega.',
  color: 'bg-secondary',
  rotate: 'rotate-1'
}, {
  emoji: '🐕',
  name: 'Rocky',
  breed: 'Bulldog',
  quote: 'Ronca más fuerte que un motor.',
  color: 'bg-accent',
  rotate: '-rotate-2'
}, {
  emoji: '🐈',
  name: 'Michi',
  breed: 'Siamés',
  quote: 'Exige atención inmediata.',
  color: 'bg-white',
  rotate: 'rotate-2'
}];
export const HappyPatients: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  return <section className="py-24 bg-bg overflow-hidden" data-id="element-64">
      <div className="container mx-auto px-4 mb-12" data-id="element-65">
        <SectionHeading title="Nuestros pacientes felices 🐾" subtitle="Ellos ya son parte de la familia Patitas Felices." align="left" data-id="element-66" />
      </div>

      {/* Horizontal Scrolling Gallery */}
      <div className="relative w-full overflow-x-auto pb-12 pt-4 px-4 hide-scrollbar" ref={containerRef} data-id="element-67">
        <div className="flex gap-6 w-max px-4 md:px-8" data-id="element-68">
          {patients.map((patient, index) => <motion.div key={index} whileHover={{
          scale: 1.05,
          y: -10,
          zIndex: 10
        }} className={`${patient.color} border-3 border-text rounded-3xl p-6 w-72 flex-shrink-0 neo-shadow transform ${patient.rotate} transition-all duration-300`} data-id="element-69">
              <div className="bg-white border-3 border-text rounded-full w-32 h-32 mx-auto mb-6 flex items-center justify-center text-7xl neo-shadow-sm" data-id="element-70">
                {patient.emoji}
              </div>
              <div className="text-center" data-id="element-71">
                <h3 className="text-2xl font-black mb-1" data-id="element-72">{patient.name}</h3>
                <p className="text-sm font-bold text-gray-600 mb-4 uppercase tracking-wider" data-id="element-73">
                  {patient.breed}
                </p>
                <div className="bg-white border-2 border-text rounded-xl p-3 text-sm font-medium italic relative" data-id="element-74">
                  "{patient.quote}"{/* Small decorative quote mark */}
                  <div className="absolute -top-3 -left-2 text-2xl" data-id="element-75">✨</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `
    }} data-id="element-76" />
    </section>;
};